module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp--dark-a1de8d2a7d3c2669c7851c9842c34d65.png";